import { UseAuthModalsResult } from '../../hooks/auth/useAuthModals';
import VerificationModal from './VerificationModal';
import InviteOnlyModal from './InviteOnlyModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import { FailedNotification } from './FailedNotification';
import config from '../../config';

interface AuthModalsGroupProps {
  modals: UseAuthModalsResult;
  email: string;
  onLoginAfterVerification: () => Promise<void>;
  onForgotPasswordSuccess?: () => void;
}

/**
 * Groups all authentication-related modals together.
 */
export const AuthModalsGroup = ({
  modals,
  email,
  onLoginAfterVerification,
  onForgotPasswordSuccess,
}: AuthModalsGroupProps) => {
  return (
    <>
      <FailedNotification
        show={modals.failureNotification.isOpen}
        setShow={(show) => (show ? null : modals.failureNotification.close())}
        title="Login failed"
        body={modals.failureNotification.message || 'Wrong username or password'}
      />

      <InviteOnlyModal
        open={modals.inviteOnly.isOpen}
        setOpen={(open) => (open ? modals.inviteOnly.open() : modals.inviteOnly.close())}
      />

      {modals.verification.isOpen && (
        <VerificationModal
          clientId={config.cognito.clientId}
          region={config.cognito.region}
          email={email}
          loginFunc={onLoginAfterVerification}
        />
      )}

      <ForgotPasswordModal
        isOpen={modals.forgotPassword.isOpen}
        onClose={modals.forgotPassword.close}
        onSuccess={() => {
          onForgotPasswordSuccess?.();
        }}
      />
    </>
  );
};
